import React,{useEffect,useState} from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminGalleryManager.css";

const API="/api/gallery";

const AdminGalleryManager=()=>{

/* ================= STATES ================= */

const [events,setEvents]=useState([]);
const [filtered,setFiltered]=useState([]);
const [categoryFilter,setCategoryFilter]=useState("");

const [editingId,setEditingId]=useState(null);

const [form,setForm]=useState({
event_title:"",
event_category:"",
event_date:"",
event_place:"",
event_description:""
});

const [mainImage,setMainImage]=useState(null);
const [mainPreview,setMainPreview]=useState("");

const [images,setImages]=useState([]);
const [imagePreview,setImagePreview]=useState([]);

/* ================= DATE FORMAT ================= */

const formatDate=(date)=>{
    return new Date(date).toLocaleDateString("en-IN",{
    day:"2-digit",
    month:"2-digit",
    year:"numeric"
    }).replace(/\//g,"-");
    };

/* ================= LOAD EVENTS ================= */

const loadEvents=()=>{
axios.get(API)
.then(res=>{

const sorted=res.data.sort(
(a,b)=>new Date(b.event_date)-new Date(a.event_date)
);

setEvents(sorted);
setFiltered(sorted);

})
.catch(err=>console.log(err));

};

useEffect(()=>{

loadEvents();

},[]);

/* ================= FORM CHANGE ================= */

const handleChange=(e)=>{

setForm({
...form,
[e.target.name]:e.target.value
});

};

/* ================= MAIN IMAGE ================= */

const handleMainImage=(e)=>{

const file=e.target.files[0];

setMainImage(file);

if(file){
setMainPreview(URL.createObjectURL(file));
}

};

/* ================= MULTIPLE IMAGES ================= */

const handleImages=(e)=>{

const files=[...e.target.files];

setImages(files);

const previews=files.map(file=>URL.createObjectURL(file));

setImagePreview(previews);

};

/* ================= DRAG DROP ================= */

const handleDrop=(e)=>{

e.preventDefault();

const files=[...e.dataTransfer.files];

setImages(files);

const previews=files.map(file=>URL.createObjectURL(file));

setImagePreview(previews);

};

const allowDrop=(e)=>{

e.preventDefault();

};

/* ================= ADD / UPDATE EVENT ================= */

const saveEvent = () => {

  // ? VALIDATION (VERY IMPORTANT)
  if (!form.event_title.trim()) {
    alert("Event Title is required");
    return;
  }

  if (!form.event_category) {
    alert("Please select category");
    return;
  }

  if (!form.event_date) {
    alert("Please select date");
    return;
  }

  const data = new FormData();

  data.append("event_title", form.event_title);
  data.append("event_category", form.event_category);
  data.append("event_date", form.event_date);
  data.append("event_place", form.event_place);
  data.append("event_description", form.event_description);

  if (mainImage) data.append("main_image", mainImage);
  images.forEach(img => data.append("images", img));

  if (editingId) {
    axios.put(`${API}/${editingId}`, data)
      .then(() => {
        resetForm();
        loadEvents();
      })
      .catch(err => {
        console.log(err);
        alert("Update failed");
      });
  } else {
    axios.post(API, data)
      .then(() => {
        resetForm();
        loadEvents();
      })
      .catch(err => {
        console.log(err);
        alert("Add failed");
      });
  }
};

/* ================= EDIT EVENT ================= */

const editEvent=(event)=>{

setEditingId(event.id);

setForm({
event_title:event.event_title,
event_category:event.event_category,
event_date:event.event_date,
event_place:event.event_place,
event_description:event.event_description
});

if(event.main_image){

setMainPreview(
`${BASE_URL}/uploads/gallery/${event.main_image}`
);

}

};

/* ================= DELETE EVENT ================= */

const deleteEvent=(id)=>{

if(!window.confirm("Delete this event?")) return;

axios.delete(`${API}/${id}`)
.then(()=>loadEvents());

};

/* ================= DELETE IMAGE ================= */

const deleteImage=(id)=>{

if(!window.confirm("Delete this image?")) return;

axios.delete(`${API}/image/${id}`)
.then(()=>loadEvents());

};

/* ================= FILTER ================= */

const filterCategory=(value)=>{

setCategoryFilter(value);

if(!value){
setFiltered(events);
return;
}

const filteredList=events.filter(
e=>e.event_category===value
);

setFiltered(filteredList);

};

/* ================= RESET ================= */

const resetForm=()=>{

setEditingId(null);

setForm({
event_title:"",
event_category:"",
event_date:"",
event_place:"",
event_description:""
});

setMainImage(null);
setMainPreview("");
setImages([]);
setImagePreview([]);

};

/* ================= RENDER ================= */

return(

<div className="container mt-4">

<h2>Gallery Manager</h2>

{/* CATEGORY FILTER */}

<div className="mb-3">

<select
className="form-select"
value={categoryFilter}
onChange={(e)=>filterCategory(e.target.value)}
>

<option value="">Select Category</option>
<option value="National Event">National Event</option>
<option value="Festival">Festival</option>
<option value="Function">Function</option>
<option value="Sports">Sports</option>
<option value="School">School</option>
<option value="Class">Class</option>
<option value="Laboratory">Laboratory</option>
<option value="Library">Library</option>
<option value="Computer">Computer</option>
<option value="Competition">Competition</option>
<option value="Seminar">Seminar</option>
<option value="Workshop">Workshop</option>
<option value="Social Activity">Social Activity</option>
<option value="Farewell">Farewell</option>
<option value="Party">Party</option>
<option value="Tour">Tour</option>
<option value="Academic">Academic</option>
<option value="Cultural">Cultural</option>
<option value="Advertisement">Advertisement</option>
<option value="School Songs">School Songs</option>
<option value="Other">Others</option>

</select>

</div>

{/* EVENT FORM */}

<div className="card p-3 mb-4">

<h4>{editingId?"Edit Event":"ADD EVENT"}</h4>

<input
className="form-control mb-2"
name="event_title"
placeholder="Event Title"
value={form.event_title}
onChange={handleChange}
/>

{/* CATEGORY DROPDOWN */}

<select
className="form-control mb-2"
name="event_category"
value={form.event_category}
onChange={handleChange}
>

<option value="">Select Category</option>
<option value="National Event">National Event</option>
<option value="Festival">Festival</option>
<option value="Function">Function</option>
<option value="Sports">Sports</option>
<option value="School">School</option>
<option value="Class">Class</option>
<option value="Laboratory">Laboratory</option>
<option value="Library">Library</option>
<option value="Computer">Computer</option>
<option value="Competition">Competition</option>
<option value="Seminar">Seminar</option>
<option value="Workshop">Workshop</option>
<option value="Social Activity">Social Activity</option>
<option value="Farewell">Farewell</option>
<option value="Party">Party</option>
<option value="Tour">Tour</option>
<option value="Academic">Academic</option>
<option value="Cultural">Cultural</option>
<option value="Advertisement">Advertisement</option>
<option value="School Songs">School Songs</option>
<option value="Other">Others</option>
</select>

<input
type="date"
className="form-control mb-2"
name="event_date"
value={form.event_date}
onChange={handleChange}
/>

<input
className="form-control mb-2"
name="event_place"
placeholder="Event Place"
value={form.event_place}
onChange={handleChange}
/>

<textarea
className="form-control mb-2"
name="event_description"
placeholder="Event Description"
value={form.event_description}
onChange={handleChange}
/>

{/* MAIN IMAGE */}

<div className="mb-3">

<label>Cover Image</label>

<input
type="file"
className="form-control"
onChange={handleMainImage}
/>

{mainPreview &&
<img
src={mainPreview}
alt=""
style={{width:"150px",marginTop:"10px"}}
/>
}

</div>

{/* MULTIPLE MEDIA */}

<div
className="border p-3 mb-3"
onDrop={handleDrop}
onDragOver={allowDrop}
>

<p>Drag & Drop Images or Videos</p>

<input
type="file"
multiple
className="form-control"
onChange={handleImages}
/>

<div style={{display:"flex",flexWrap:"wrap",marginTop:"10px"}}>

{images.map((file,i)=>{
  const url = URL.createObjectURL(file);
  const isVideo = file.type.startsWith("video");
  return isVideo ? (
    <video key={i} width={100} height={80} controls style={{marginRight:10,marginBottom:10}}>
      <source src={url} type={file.type} />
    </video>
  ) : (
    <img key={i} src={url} style={{width:100,height:80,objectFit:"cover",marginRight:10,marginBottom:10}} />
  );
})}

</div>

</div>

<button
className="btn btn-primary me-2"
onClick={saveEvent}
>

{editingId?"Update Event":"Add Event"}

</button>

<button
className="btn btn-secondary me-2"
onClick={resetForm}
>

Reset

</button>

</div>

{/* EVENT LIST */}

<table className="table table-bordered">

<thead>

<tr>
<th>Cover</th>
<th>Title</th>
<th>Date</th>
<th>Category</th>
<th>Actions</th>
</tr>

</thead>

<tbody>

{filtered.map(event=>{

const cover=`${BASE_URL}/uploads/gallery/${event.main_image}`;

return(

<tr key={event.id}>

<td>

<img
src={cover}
alt=""
style={{
width:"100px",
height:"70px",
objectFit:"cover"
}}
/>

</td>

<td>{event.event_title}</td>
{/* <td>{event.event_date}</td> */}
<td>{formatDate(event.event_date)}</td>
<td>{event.event_category}</td>

<td>

<button
className="btn btn-warning btn-sm me-2"
onClick={()=>editEvent(event)}
>
Edit
</button>

<button
className="btn btn-danger btn-sm"
onClick={()=>deleteEvent(event.id)}
>
Delete
</button>

</td>

</tr>

);

})}

</tbody>

</table>

{/* MEDIA */}

{filtered.map(event=>{

if(!event.images || event.images.length===0) return null;

return(

<div key={event.id} className="mb-4">

<h5>{event.event_title} Images</h5>

<div className="media-grid">

{event.images.map(media=>{

const url=`${BASE_URL}/uploads/gallery/${media.image_path}`;

return(

<div key={media.id} className="media-box">

{media.file_type==="video" ? (

<video width="140" controls>
<source src={url} type="video/mp4"/>
</video>

) : (

<img src={url} alt=""/>

)}

<button
className="delete-media"
onClick={()=>deleteImage(media.id)}
>
Delete
</button>

</div>

);

})}

</div>

</div>
);
})}

</div>

);

};

export default AdminGalleryManager;